import { Injectable } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UnauthorizedRedirectInterceptor implements HttpInterceptor {
  constructor(private readonly router: Router) {}

  static readonly SKIP_UNAUTHORIZED_REDIRECT = new HttpContextToken<boolean>(() => false);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const skipRedirect = req.context.get(UnauthorizedRedirectInterceptor.SKIP_UNAUTHORIZED_REDIRECT);
        if (error.status === 401 && req.url.includes('/api/') && !skipRedirect && this.router.url !== '/access-denied') {
          void this.router.navigate(['/access-denied']);
        }

        return throwError(() => error);
      }),
    );
  }
}
